// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"ed27c79b","153":"e31bddfa","180":"a64973e2","310":"fa1aea8e","453":"7f709e95","804":"bc7ceb1c","813":"c39f2275"}[chunkId] + ".chunk.js";
};